import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// Model
import { ResponseBase } from '../models/response-base';
import { OpcaoCadastroArquivo } from '../models/opcao-cadastro-arquivo';

@Injectable({
    providedIn: 'root'
})
export class ArquivoService {

    API: string = environment.API + 'Information';    

    constructor(private http: HttpClient) { }

    getOpcoesArquivo(tipoOpcaoArquivo: string): Observable<ResponseBase<OpcaoCadastroArquivo[]>> {
        return this.http.get<ResponseBase<OpcaoCadastroArquivo[]>>(`${this.API}/opcoes/cadastro/arquivo/${tipoOpcaoArquivo}`);
    }   
}
